import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

const BulkActionCheckBox = ({
  onChange,
  checked,
  selectedLength,
  totalLength,
  inputProps,
  className,
}) => {
  const calculateIndeterminate = () => {
    return selectedLength > 0 && selectedLength < totalLength;
  };

  return (
    <Checkbox
      onChange={onChange}
      checked={checked || false}
      indeterminate={calculateIndeterminate()}
      inputProps={inputProps}
      classes={{
        indeterminate: className,
      }}
    />
  );
};

export default BulkActionCheckBox;
